module.exports = __webpack_public_path__ + "img/apiTeam.295f6a25.svg";